module.exports = __webpack_public_path__ + "img/marker_two_green1.f8444725.png";